import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DeviceEditPage } from './device-edit';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		DeviceEditPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(DeviceEditPage),
	],
})
export class DeviceEditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/device-edit/device-edit.module.ts